import { Card, Grid, Typography } from "@material-ui/core";
import { mainContentColor, modalStressTextColor } from '../../lib/Color';
import { PositionType } from "../../Type/TeamType";

export type BattleResultMemberType = {
    heroId?: number;
    leftExtensionId?: number,
    rightExtensionId?: number,
    hp?: number,
    phy?: number,
    int?: number,
    agi?: number
}

type Props = BattleResultMemberType & {
    position: PositionType;
}

const TeamAreaRow = ({ position, heroId, leftExtensionId, rightExtensionId, hp, phy, int, agi }: Props) => {
    return <Card style={{ background: mainContentColor, margin: "10px", width: 256 }}>
        <div>
            <Typography style={{ color: modalStressTextColor, margin: "5" }}>{position}</Typography>
        </div>
        <Grid container alignItems="center" justify="center">
            <Grid item>
                <div style={{ float: "left" }}>
                    <div>
                        <img
                            src={`https://www.mycryptoheroes.net/images/heroes/2000/${heroId}.png`}
                            style={{ width: 128, height: 128 }}
                        />
                    </div>
                    <div>
                        <img
                            src={`https://d2fvodbijouf8s.cloudfront.net/images/extensions/64/${leftExtensionId}.png`}
                            style={{ width: 64, height: 64 }}
                        />
                        <img
                            src={`https://d2fvodbijouf8s.cloudfront.net/images/extensions/64/${rightExtensionId}.png`}
                            style={{ width: 64, height: 64 }}
                        />
                    </div>
                </div>
                <div>
                    <div style={{ margin: "5" }}>
                        <Typography style={{ color: modalStressTextColor, margin: "10" }}> HP: {hp} PHY: {phy}</Typography>
                        <Typography style={{ color: modalStressTextColor, margin: "10" }}> INT: {int} AGI: {agi}</Typography>
                    </div>
                </div>
            </Grid>
        </Grid>
    </Card>
}

export default TeamAreaRow;